<template>
    <div class="float-left mr-1">
        <span class="text-danger">
            <i
                class="fa fa-trash fa-lg icon-button"
                title="Excluir Anexo"
                @click.stop="confirmarExcluir()"
            ></i>
        </span>
    </div>
</template>

<script>
import ParcelamentoServicos from '../ParcelamentoServicos'

export default {
    props: {
        anexo: {
            type: Object,
            default: () => ({})
        },

        parcelamento: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluir() {
            this.$swal({
                title: 'Anexo',
                html: `Confirma a exclusão do Anexo de descrição <b>${this.anexo.descricao}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluir()
                }
            })
        },

        excluir() {
            this.$store.dispatch('addRequest')
            let anexoDto = {
                idContrato: this.$route.params.contratoId,
                idInvestimentoPrevistoContrato: this.parcelamento.idInvestimentoPrevistoContrato,
                idParcela: this.anexo.idParcelaInvestimentoPrevistoContrato,
                idDocumento: this.anexo.idDocumentoParcelaInvestimentoPrevistoContrato
            }
            ParcelamentoServicos.excluirAnexo(anexoDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Registro excluído com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterAnexosAtualizados')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
